module.exports = __webpack_public_path__ + "static/media/draggedDrill.d0d7a769.png";